import { Box, Stack } from "@chakra-ui/react"
import React, { PropsWithChildren } from "react"

export const Contents = ({ children }: PropsWithChildren) => {
  const registerSentinel = (el: HTMLDivElement) => {
    if (!el) return

    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        el.parentElement?.setAttribute(
          "data-scrollable",
          String(!entry.isIntersecting)
        )
      },
      {
        threshold: 1,
        root: el.parentElement,
      }
    )

    intersectionObserver.observe(el)
  }
  return (
    <Box
      data-menu-contents
      overflowY="auto"
      borderTopColor="ds.border.default"
      borderTopWidth={{ base: "1px", sm: 0 }}
      pos={{ base: "static", sm: "sticky" }}
      top="var(--navigation-menu-sticky-top)"
      height={{
        sm: "calc(100vh - var(--navigation-menu-footer-height) - var(--navigation-menu-sticky-top) - var(--navigation-menu-scrollable-top) + var(--navigation-menu-scroll-offset))",
      }}
    >
      <Stack p={4} gap={2}>
        {children}
      </Stack>
      <Box ref={registerSentinel} mt={-4} h={4} pointerEvents="none" />
    </Box>
  )
}
